export const API_BASE_URL = "http://localhost:1212";
